import { ScriptTextOutlineIcon } from './ScriptTextOutlineIcon';

/**
 * author: Austin Andrews
 * id DF9F9175-8E37-4241-8AFD-360606A444A5
 * name script-text-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/script-text-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ScrollTextOutlineIcon = ScriptTextOutlineIcon;
export default ScrollTextOutlineIcon